import { render, staticRenderFns } from "./PromocodesNew.vue?vue&type=template&id=399ade05&scoped=true"
import script from "./PromocodesNew.vue?vue&type=script&lang=js"
export * from "./PromocodesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ade05",
  null
  
)

export default component.exports